// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = 4
// module chunks = 0